import { sendSmsChannelMessage } from 'services/smsConversations';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ISendSmsMessagePayload, ISmsChannelHistory } from 'services/smsConversations/types';

export const ThunkSendSmsChannelMessage = createAsyncThunk<
  ISmsChannelHistory,
  { channelId: number; payload: ISendSmsMessagePayload }
>('pod/sendSmsChannelMessage', async ({ channelId, payload }) => {
  const r = await sendSmsChannelMessage(channelId, payload);
  return r.data;
});
